<template>
  <button @click="open" class="btn btn-sm btn-info mr-1 mb-1">
    <font-awesome-icon icon="road"/>&nbsp;{{ $t('clientTrialExtendRequest') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('clientTrialExtendRequest')">
      <p><b>{{$t('companyName')}}: </b>{{client.companyName}}</p>
      <p><b>{{$t('domain')}}: </b>{{client.domain}}</p>
      <p><b>{{$t('expireTime')}}: </b>{{client.expireTime | moment('DD/MM/YY HH:mm:ss')}}</p>
      <form-input :label="$t('numberOfDayToExtend')" attribute="numberOfDay" :model="formModel" :errors="formErrors" :placeholder="$t('numberOfDayToExtendPlaceholder')"></form-input>
      <form-textarea :label="$t('requestNote')" attribute="requestNote" :model="formModel" :errors="formErrors" :placeholder="$t('requestNotePlaceholder')"></form-textarea>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button :disabled="!formModel.numberOfDay" class="btn btn-primary float-right" @click="request()">
          {{ $t('request') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>

<script>
export default {
  props: ['client'],
  data() {
    return {
      showForm: false,
      formModel: {
        numberOfDay: 3
      },
      formErrors: []
    }
  },
  methods: {
    open() {
      this.formModel = {
        client: this.client._id,
        numberOfDay: 3
      };
      this.showForm = true;
    },
    request() {
      let loader = this.$loading.show();
      this.$service({
        url: '/client-trial-extend-request',
        method: 'post',
        data: this.formModel
      }).then(response => {
        this.showForm = false;
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('requestSuccess'),
            icon: 'success'
          });
          this.$bus.$emit('loadClient');
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('requestFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    }
  },
  i18n: {
    messages: {
      en: {
        numberOfDayToExtend: "Number of day to extend",
        requestSuccess: "Request created!",
        numberOfDayToExtendPlaceholder: "Input number of day to extend",
        requestNote: "Request note",
        requestNotePlaceholder: "Reason for this extend request",
      },
      vi: {
        numberOfDayToExtend: "Số ngày muốn gia hạn dùng thử",
        requestSuccess: "Tạo yêu cầu thành công!",
        numberOfDayToExtendPlaceholder: "Nhập số ngày muốn xin gia hạn",
        requestNote: "Ghi chú",
        requestNotePlaceholder: "Trình bày lý do cần gia hạn",
      }
    }
  }
}
</script>